
import { Vue, Options } from "vue-class-component";
@Options({
  props: {
    toastShow: Boolean,
    minPerson: Number
  },
  emits: {
    isshowaction: () => {
      return true;
    }
  }
})
/*开奖时刻，首次进来，没有开奖*/
export default class NotDrawToast extends Vue {
  close() {
    console.log("NotDrawToastClose");
  }
}
